import { VAutocomplete } from 'vuetify/lib'
import { defaultFun } from '../utils'
import { AUTOCOMPLETES } from '../type_name'
import commonMixins from './commonMixins'
export default {
    name: AUTOCOMPLETES,
    mixins: [ commonMixins ],
    render(h) {
        let update_search_input = defaultFun
        const {
            // eslint-disable-next-line 
            slots,scopedSlots,
             key,
             _type = 'text',
             className = '',
             blur = defaultFun,
             change = defaultFun,
             click = defaultFun,
             focus = defaultFun,
             input = defaultFun,
             keydown = defaultFun,
             mousedown = defaultFun,
             mouseup = defaultFun,
             ...params 
            } = this.field
            if (params['update:search-input']) {
                update_search_input = params['update:search-input']
                delete params['update:search-input']
            }
        params.type = _type
        return h(VAutocomplete, {
            class:className,
            slots: this.slots,
            scopedSlots:  this.separateSlot && this.separateSlot(),
            props: {
                ...params,
                'no-data-text':params.noDataText || '暂无数据',
                value: this.my_value[key]
            },
            on: {
                blur,
                change:(data) => {
                   if (change) {
                    this.my_value[key] = data
                    change(data)
                   }
                 
                },
                click,
                focus,
                input,
                keydown,
                mousedown,
                mouseup,
                'update:search-input': update_search_input
            }
        })
    }
}